module.exports = __webpack_public_path__ + "static/media/microsoft-word.b54f7334.svg";